import { EGerdauService } from '../EGerdauService';
import {
  customersAuthorizationApi,
  ECustomerAuthorizationEndpoints
} from '../api';

interface ShipToCustomerResponse {
  shipToCustomers: IShipToCustomerItem[];
}

export interface IShipToCustomerItem {
  address: string;
  city: string;
  customerId: string;
  name: string;
  state: string;
  taxNumber: string;
  postalCode: string;
}

export class EntryOrderService extends EGerdauService {
  public async loadShipToCustomer(
    customerId: string
  ): Promise<IShipToCustomerItem[]> {
    const headers = super.getHeaders();
    const requestURL = ECustomerAuthorizationEndpoints.SHIP_TO_CUSTOMER;
    const response = await customersAuthorizationApi.get(
      `${requestURL}?customer=${customerId}`,
      {
        headers
      }
    );

    return (response?.data as ShipToCustomerResponse)?.shipToCustomers || [];
  }
}
